<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>
    <v-container>
      <h1 class="subheading grey--text">Lead Categories</h1>

      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Category</th>
            <th class="text-left">Leads</th>
            <th class="text-left">Leads Contacted</th>
             <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in categories" :key="category._id">
            <td>{{category.name}}</td>
            <td>{{category.leadCount}}</td>
            <td>{{category.contactedCount}}</td>
            <td>
              <v-btn :to="'/leads/'+category._id" small>View Leads</v-btn>

            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { categoryLoadApi } from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: true,
    categories: null
  }),
  name: "Categories",
  methods: {
    async loadCategories() {
      let userToken = firebase.auth().currentUser.uid;
      let categoryList = await axios.get(`${categoryLoadApi}${userToken}`);

      //console.log("CATEGORIES", categoryList);
      if (categoryList.data.success === true) {
        this.categories = categoryList.data.result;
      }
    },
    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 1000);
    }
  },

  mounted() {
    this.loadCategories();
    this.closeLoadingModal();
  }
};
</script>

<style scoped>
</style>